import { searchContactPoints } from "../../../../../../../../../../../../../api/kehrblatt/customer-registry/contact-points"
import {
  mergeContactPointsById,
  missingRecipientCustomerIdsForContactPoints,
  recipientCustomerIdsForContactOrderWorkOrders,
} from "../_logic/contactProjection"
import { isPhoneContactPointKind } from "../../../../../../../../../../../_shared/_logic/contact-point-kinds"

const contactPointCounts = (points: ContactPoint[]) => {
  const kindFor = (point: ContactPoint) => `${point.kind ?? ""}`.toUpperCase()

  return {
    contact_point_count: points.length,
    email_count: points.filter((point) => kindFor(point) === "EMAIL").length,
    phone_count: points.filter((point) => isPhoneContactPointKind(point.kind)).length,
    address_count: points.filter((point) => kindFor(point) === "ADDRESS").length,
  }
}

export const loadBatchContactPoints = async ({
  organizationId,
  seedContactPoints,
  workOrders,
}: {
  organizationId: string
  seedContactPoints: ContactPoint[]
  workOrders: WorkOrder[]
}) => {
  const recipientCustomerIds = recipientCustomerIdsForContactOrderWorkOrders(workOrders)

  if (!recipientCustomerIds.length) {
    return {
      loadedContactPoints: [],
      effectiveContactPoints: seedContactPoints,
    }
  }

  const missingCustomerIds = missingRecipientCustomerIdsForContactPoints({
    workOrders,
    contactPoints: seedContactPoints,
  })

  if (!missingCustomerIds.length) {
    console.info("batch_contact_order_contact_points_loaded", {
      recipient_count: recipientCustomerIds.length,
      requested_customer_count: 0,
      skipped: true,
      ...contactPointCounts([]),
      duration_ms: 0,
    })

    return {
      loadedContactPoints: [],
      effectiveContactPoints: seedContactPoints,
    }
  }

  const startedAt =
    typeof performance !== "undefined" && typeof performance.now === "function"
      ? performance.now()
      : Date.now()
  const loadedContactPoints = await searchContactPoints({
    organizationId,
    customerIds: missingCustomerIds,
  })
  const elapsedMs = Math.round(
    (typeof performance !== "undefined" && typeof performance.now === "function"
      ? performance.now()
      : Date.now()) - startedAt,
  )
  console.info("batch_contact_order_contact_points_loaded", {
    recipient_count: recipientCustomerIds.length,
    requested_customer_count: missingCustomerIds.length,
    ...contactPointCounts(loadedContactPoints),
    duration_ms: elapsedMs,
  })

  return {
    loadedContactPoints,
    effectiveContactPoints: mergeContactPointsById(seedContactPoints, loadedContactPoints),
  }
}
